(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('shoppers', {
          abstract: true,
          parent : 'storePage',
          url : '/shoppers',
          template : '<ui-view autoscroll="true"></ui-view>'
        })
        .state('shoppers.summary', {
          url : '/summary',
          data: {
            auth : { privilege : 'report.Shoppers' },
            title:'Shoppers Summary',
            path:'shoppers/summary'
          },
          templateUrl : 'StandardReports/Shoppers/Summary/ShopperSummary.tmpl.html',
          controller : 'ShopperSummaryCtrl as vm'
        })
        .state('shoppers.sessions', {
          url : '/sessions',
          data: {
            auth : { privilege : 'report.Shoppers' },
            title:'Shoppers Sessions',
            path:'shoppers/sessions'
          },
          templateUrl : 'StandardReports/Shoppers/Sessions/ShopperSessions.tmpl.html',
          controller : 'ShopperSessionsCtrl as vm'
        })
        .state('shoppers.activeUsers', {
          url : '/active-users',
          data: {
            auth : { privilege : 'report.Shoppers' },
            title:'Shoppers Active Users',
            path:'shoppers/active-users'
          },
          templateUrl : 'StandardReports/Shoppers/ActiveUsers/ActiveUsers.tmpl.html',
          controller : 'ActiveUsersCtrl as vm'
        })
        .state('shoppers.adoption', {
          url : '/adoption',
          data: {
            auth : { privilege : 'report.Shoppers' },
            title:'Shoppers Adoption',
            path:'shoppers/adoption'
          },
          templateUrl : 'StandardReports/Shoppers/Adoption/ShopperAdoption.tmpl.html',
          controller : 'ShopperAdoptionCtrl as vm'
        })
        .state('shoppers.kids', {
          url : '/kids',
          data: {
            auth : { privilege : 'report.KidsProfiles' },
            title:'Shoppers Kids',
            path:'shoppers/kids'
          },
          templateUrl : 'StandardReports/Shoppers/RecipientProfiles/RecipientProfiles.tmpl.html',
          controller : 'KidsProfilesCtrl as vm'
        })
        .state('shoppers.sfo', {
          url : '/sfo',
          data: {
            auth : { privilege : 'report.SFOProfiles' },
            title:'Shoppers SFO',
            path:'shoppers/sfo'
          },
          templateUrl : 'StandardReports/Shoppers/RecipientProfiles/RecipientProfiles.tmpl.html',
          controller : 'SFOProfilesCtrl as vm'
        })
        .state('shoppers.shopperProfiles', {
          url : '/shopper-profiles',
          data: {
            auth : { privilege : 'report.ShopperProfiles' },
            title:'Shoppers Profiles',
            path:'shoppers/shopper-profiles'
          },
          resolve: {
            genderData: function (filters, storeKeys, StandardReports, ReportFormat) {
              var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
              return StandardReports.getConsumerData('gender', ReportFormat.Daily, queryFilters).then(function (data) {
                return _(data.profileValues)
                    .flatMap('rangeMetricValues')
                    .sortBy('range')
                    .value();

              });
            }
          },
          templateUrl : 'StandardReports/Shoppers/ShopperProfiles/ShopperProfiles.tmpl.html',
          controller : 'ShopperProfilesCtrl as vm'
        });
  }

})();